import React from 'react';
import BaseIcon from 'assets/icons/BaseIcon';

class PortIcon extends BaseIcon {
    render() {
        return (<svg version='1.1' id='port' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>
            <g>
                <path
                    fill={ this.props.primary }
                    d='M84.57,12.71c10.58,0,20.95,0,31.58,0c1.42,6.18,3,12.33,4.19,18.55c0.48,2.48,1.57,2.99,3.83,2.93
                    c5.28-0.14,10.56-0.05,15.85-0.05c10.02,0.01,16.48,6.08,16.66,16.17c0.22,12.38,0.17,24.77,0.02,37.16
                    c-0.03,2.86,0.67,4.49,3.49,5.44c2.92,0.98,5.67,2.44,8.49,3.72c5.04,2.28,6.84,5.64,5.25,11.01
                    c-5.44,18.3-11.04,36.55-16.68,54.79c-0.21,0.69-1.51,1.51-2.27,1.48c-5.34-0.18-10.25-2.02-14.37-5.28
                    c-4.33-3.42-8.23-7.38-12.52-11.29c-7.07,8.59-15.23,16.6-27.94,16.66c-12.79,0.06-21.04-7.82-28.64-17.17
                    c-0.74,0.97-1.38,1.82-2.04,2.65c-5.7,7.23-12.7,12.47-21.94,14.24c-4.23,0.81-4.33,0.75-5.52-3.25
                    c-5.23-17.51-10.46-35.02-15.69-52.52c-2-6.69-0.35-10.06,6.17-12.56c2.63-1.01,5.23-2.13,7.92-2.96c2.05-0.63,2.78-1.63,2.75-3.88
                    c-0.13-12.11-0.27-24.23,0.07-36.34c0.1-3.59,1.2-7.4,2.81-10.63c2.49-4.98,6.96-7.5,12.71-7.45c5.83,0.05,11.66-0.1,17.49,0.06
                    c2.19,0.06,2.97-0.77,3.46-2.76C81.21,25.18,82.92,18.97,84.57,12.71z M142.16,85.44c0-11.63,0-22.76,0-33.91
                    c-28.25,0-56.24,0-84.38,0c0,11.31,0,22.45,0,33.94c1.15-0.43,2.06-0.77,2.96-1.12c12.35-4.83,24.69-9.7,37.08-14.42
                    c1.27-0.48,3.03-0.48,4.3,0c11.63,4.43,23.2,9.02,34.79,13.56C138.58,84.14,140.27,84.74,142.16,85.44z'/>
                <path
                    fill={ this.props.primary }
                    d='M172.4,187.15c-13.73-0.28-26.6-3.53-38.75-9.54c-1.58-0.78-2.69-0.77-4.22,0.04c-19.11,10.15-38.3,10.18-57.44,0.08
                    c-1.61-0.85-2.8-0.88-4.47-0.07c-12.58,6.15-25.86,9.53-39.93,9.63c16.37-4.52,30.06-13.95,43.73-23.68
                    c1.85,1.27,3.68,2.59,5.58,3.8c16.73,10.66,33.9,10.21,49.91-1.45c1.82-1.32,2.89-1.28,4.66,0c10.23,7.33,20.87,13.98,32.69,18.5
                    C166.86,185.49,169.65,186.26,172.4,187.15z'/>
            </g>
        </svg>);
    }
}

export default PortIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/PortIcon.js